<div class="filter-title">
  <app-pencil-icon *ngIf="showFilterIcon" name="tune" [type]="IconTypes.svgIcon"></app-pencil-icon>
  <span class="title">{{ 'Filters' | translate }}</span>
</div>
<div class="options">
  <app-pencil-button
    *ngIf="showResetButton"
    class="pencil-button small tertiary"
    (click)="onReset()"
    [label]="'Reset' | translate"
  ></app-pencil-button>
  <app-pencil-button
    *ngIf="showCloseButton"
    icon="close"
    [iconConfig]="{ type: IconTypes.materialIcon }"
    (click)="onCloseClicked()"
    class="pencil-button small tertiary close-btn"
  ></app-pencil-button>
</div>
